export const formatNumber = (number) =>
  new Intl.NumberFormat('en', {
    style: 'decimal',
    maximumFractionDigits: 6,
  }).format(number);
